import DayJSPlugin from 'dayjs';
import ru from 'dayjs/locale/ru';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

DayJSPlugin.locale(ru);

DayJSPlugin.extend(utc);
DayJSPlugin.extend(timezone);
DayJSPlugin.extend(duration);

export const dayjs = DayJSPlugin;
